/**
 * Shared helpers for reading product swatch selections.
 * Shopify indices: option0 = Color (variant.option1), option1 = Cover Material (variant.option2).
 */
(function () {
  var COLOR_INDEX = 0;
  var FABRIC_INDEX = 1;
  var MAX_OPTIONS = 3;

  function getSelectedOptionValue(index) {
    var radio = document.querySelector('input[type="radio"][name="option' + index + '"]:checked');
    return radio && radio.value ? radio.value : null;
  }

  function getColorAndFabricSelections() {
    return {
      color: getSelectedOptionValue(COLOR_INDEX),
      fabric: getSelectedOptionValue(FABRIC_INDEX)
    };
  }

  function getSelectedProductOptions() {
    var options = [];
    for (var i = 0; i < MAX_OPTIONS; i++) {
      var value = getSelectedOptionValue(i);
      if (value) {
        options.push(value);
      }
    }
    return options;
  }

  function getDisplayProductOptions() {
    var selections = getColorAndFabricSelections();
    var display = [];

    if (selections.fabric) {
      display.push(selections.fabric);
    }
    if (selections.color) {
      display.push(selections.color);
    }

    return display.length > 0 ? display : getSelectedProductOptions();
  }

  function variantMatchesProductOptions(variant, selectedOptions) {
    if (!selectedOptions || selectedOptions.length === 0) {
      return false;
    }

    if (selectedOptions.length >= 1 && variant.option1 === selectedOptions[0]) {
      if (selectedOptions.length >= 2 && variant.option2 === selectedOptions[1]) {
        return true;
      }
      if (selectedOptions.length === 1) {
        return true;
      }
    }

    return false;
  }

  function variantMatchesColorAndFabric(variant, color, fabric) {
    if (!color || !fabric) {
      return false;
    }

    return variant.option1 === color && variant.option2 === fabric;
  }

  window.getColorAndFabricSelections = getColorAndFabricSelections;
  window.getSelectedProductOptions = getSelectedProductOptions;
  window.getDisplayProductOptions = getDisplayProductOptions;
  window.variantMatchesProductOptions = variantMatchesProductOptions;
  window.variantMatchesColorAndFabric = variantMatchesColorAndFabric;
})();
